import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const TransportView = ({ customer, transportWork }) => {
  const getStatus = () => {
    if (customer?.status === "transport_complete") {
      return { label: "Complete", color: "bg-success/10 text-success" };
    }
    if (customer?.status === "transport_inprogress") {
      return { label: "In Progress", color: "bg-warning/10 text-warning" };
    }
    if (customer?.status === "transport_pending") {
      return {
        label: "Pending",
        color:
          "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
      };
    }
    return { label: "Not Started", color: "bg-muted text-muted-foreground" };
  };

  const status = getStatus();

  const photoSlots = [
    {
      id: "customer_kit_photo",
      title: "Customer & Kit Photo",
      description: "Customer with delivered kit",
    },
    {
      id: "panel_structure_photo",
      title: "Panel Structure Photo",
      description: "Panel structure at site",
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Truck" size={20} className="text-primary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Transport Phase
        </h2>
        <span
          className={`ml-auto inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${status.color}`}
        >
          {status.label}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {photoSlots.map((slot) => {
          const photoUrl = transportWork?.[slot.id];
          return (
            <div
              key={slot.id}
              className="p-4 rounded-lg border border-border bg-muted/30"
            >
              {photoUrl ? (
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
                  <Image
                    src={photoUrl}
                    alt={slot.title}
                    className="w-full h-full object-contain bg-muted"
                  />
                </div>
              ) : (
                <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
                  <div className="text-center">
                    <Icon
                      name="Image"
                      size={32}
                      className="mx-auto mb-2 text-muted-foreground"
                    />
                    <p className="text-sm font-medium text-foreground">
                      {slot.title}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {slot.description}
                    </p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransportView;
